import { render, staticRenderFns } from "./admin-drawer.vue?vue&type=template&id=4c60dccc&scoped=true&lang=pug"
import script from "./admin-drawer.vue?vue&type=script&lang=js"
export * from "./admin-drawer.vue?vue&type=script&lang=js"
import style0 from "./admin-drawer.vue?vue&type=style&index=0&id=4c60dccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60dccc",
  null
  
)

export default component.exports